import { HomeService } from 'app/main/admin/home/home.service';

import { Label } from "ng2-charts";
import { Component, OnInit, Input } from "@angular/core";
import {
  ChartDataSets,
  ChartOptions,
  ChartScales,
  ChartType,
} from "chart.js";

@Component({
  selector: "app-stacked-bars-app",
  templateUrl: "./stacked-bars-app.component.html",
  styleUrls: ["./stacked-bars-app.component.scss"],
})
export class StackedBarsAppComponent implements OnInit {
  @Input() barra1: any['totalAceite'];
  @Input() barra2: any['totalNaoAceite'];
  qtdUsers : number;
  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{}], yAxes: [{}] },
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
    tooltips: {
      enabled: true,
      mode: "y",
      titleFontColor: "transparent",
      titleMarginBottom: 0,
      titleFontSize: 10,
      callbacks: {
        label: (tooltipItem, chart) => {
          const realValue = chart.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
          const customValue = realValue + '%';
          return " "+customValue;
        }
      }
    },
  };
  
  public barChartType: ChartType = "horizontalBar";
  public barChartLegend = false;
  public display : ChartScales = {display : false}
  
  public barChartLabels: Label[] = ["Aceitas"];
  public chartColors: Array<any> = [
    {
      backgroundColor: "#86BC25",
    },
   
  ];

  public barChartData: ChartDataSets[] = [
    
    {
      data: [],
      label:"" ,
      stack: "A",
      // maxBarThickness: 100,
      showLine : false,
   
      
    },
   
  ];
  result: number;
  
  ngOnInit() {
    this.customizeChartBar();
  }
 
  customizeChartBar() {
    let x = Math.round((this.barra2 /23)*100) ;
    this.result = 104 -x ;
    this.barChartData[0].data.push(this.result);
   
  }
 
  

  
}
